<template>
  <b-card class="card" no-body>
    <b-container class="template">
      <b-row class="title-row-margin">
        <b-col cols="12">
          <div class="sentiment-title">
            Sentiment
          </div>
        </b-col>
      </b-row>
      <b-row class="service-section">
        <b-col class="service-col" xl="6" lg="6" md="12" sd="12" xs="12">
          <b-container class="service-container">
            <b-row class="service-row-margin">
              <IconDetail
                icon="/assets/images/sentiment_thinking.png"
                title="วิเคราะห์อารมณ์ในข้อความ"
                description="เพื่อหาว่าในอารมณ์ในข้อความเป็นความรู้สึกเชิงบวกหรือลบ"
              />
            </b-row>
            <b-row class="service-row-margin">
              <IconDetail
                icon="/assets/images/sentiment_speak.png"
                title="รองรับข้อความจาก Social Media หรือสื่อต่างๆ"
                description="ที่ประกอบด้วยคำศัพท์ไม่เป็นทางการ หรือการตั้งใจสะกดผิด"
              />
            </b-row>
            <b-row>
              <IconDetail
                icon="/assets/images/sentiment_directory.png"
                title="แสดงผลการวิเคราะห์ออกมาเป็นเปอร์เซ็นต์"
                description="เพื่อให้สามารถนำไปใช้ต่อได้อย่างหลากหลายมากขึ้น"
              />
            </b-row>
          </b-container>
        </b-col>
        <b-col class="example-col" xl="6" lg="6" md="12" sd="12" xs="12">
          <b-container class="example-container">
            <b-row class="example-row-margin">
              <div class="example-title">
                ตัวอย่างการใช้งาน Sentiment<br>
                วิเคราะห์อารมณ์ในข้อความจาก Social Media
              </div>
            </b-row>
            <b-row>
              <img class="example-image" src="/assets/images/sentiment.svg">
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row class="button-section">
        <div class="try-button" @click="trackCustomEvent({ inPage: routeName, action: 'clicked', target: 'sentiment_home_page', linkTo: 'sentiment' })">
          <router-link
            to="/demo/sentiment"
            class="btn btn-primary"
            exact
            tag="button"
          >
            ทดลองใช้งาน
          </router-link>
        </div>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import IconDetail from './IconDetail'
import { BCard, BContainer, BRow, BCol } from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  name: 'SentimentCard',
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    IconDetail
  },
  computed: {
    routeName () {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions({
      trackCustomEvent: 'trackCustomEvent'
    })
  }
}
</script>

<style scoped>

    .card {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 20px #523F690D;
        border-radius: 4px;
        opacity: 1;
        width: 100%;
        height: 100%;
        padding: 48px;
    }

    .sentiment-title {
        color: #48465B;
        opacity: 1;
        font-size: 26px;
        font-weight: 600;
    }

    .title-row-margin {
        margin-bottom: 28px;
    }

    .service-row-margin {
        margin-bottom: 36px;
    }

    .example-row-margin {
        margin-bottom: 16px;
    }

  .example-title{
    font-size: 20px;
    color: #48465B;
    font-weight: 600;
    text-align: center;
    margin-right: auto;
    margin-left: auto;
  }

  .example-image{
    width: 100%;
  }

    @media (max-width: 1025px) {
      [class*="service-col col-"] {
        margin-bottom: 60px;
      }
    }

  .service-section{
    margin-bottom: 48px;
  }

  .try-button{
    margin-left: auto;
    margin-right: auto;
  }
</style>
